import { CONSULT_CLOSE_HOUR, CONSULT_OPEN_HOUR } from "@/constants/consult";

const KST_OFFSET_HOURS = 9;

/**
 * 지금이 상담 가능 시간(한국 시간 09:00 이상 19:00 미만)인지.
 * 기기의 시간대와 상관없이 UTC 에 +9 를 더해 한국 시간을 구한다(한국은 서머타임이 없다).
 * goi_common/call.ts 의 02~07시 판정과 같은 방식이다.
 */
export const isConsultOpen = (now: Date): boolean => {
  const kstHour = (now.getUTCHours() + KST_OFFSET_HOURS) % 24;

  return kstHour >= CONSULT_OPEN_HOUR && kstHour < CONSULT_CLOSE_HOUR;
};
